"use client"

import fetchInterceptorInClient from "@/components/fetcher/fetchInterceptorInClient"
import {
  resultPostprocessing2,
} from "@/components/fetcher/fetchInterceptor"

const ROOT = process.env.NEXT_PUBLIC_ROOT

const fetchClientSelectedFolderList = (sentenceId: string) =>
  fetchInterceptorInClient(
    {
      method: "get",
      credentials: "same-origin",
    },
    ROOT,
  )(() => `/api/notebook/selected-folders/${sentenceId}`).then(
    resultPostprocessing2<{ folderId: string }[]>,
  )
export default fetchClientSelectedFolderList
